import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {RateHomeyExperienceAnonymousCommand, RateHomeyExperienceCommand} from "homey-housing-lottery-app-dto";

@Injectable({
  providedIn: 'root'
})
export class RatingService {
  private readonly http = inject(HttpClient);

  public submitRating(command: RateHomeyExperienceCommand | RateHomeyExperienceAnonymousCommand) {
    const isAnonymous = 'anonymousId' in command && !!command.anonymousId;
    const url = isAnonymous ? '/api/public/users/rating' : '/api/private/users/rating';
    return this.http.post<void>(`${environment.apiUrl}${url}`, command);
  }
}
